// Whether the bill being returned was an online order, from the till's sale
// types (read once; toArray works in both database modes).
import { useEffect, useState } from "react";
import db from "../../../../database";
import { aggregatorSaleTypeIds, isOnlineSale } from "../../../../utils/fashion/onlineOrders";

export default function useOnlineSale(order) {
  const [ids, setIds] = useState(null);
  useEffect(() => {
    let live = true;
    Promise.resolve()
      .then(() => db.posSaletypes?.toArray?.())
      .then((rows) => live && setIds(aggregatorSaleTypeIds(rows)))
      .catch(() => live && setIds(new Set()));
    return () => {
      live = false;
    };
  }, []);
  return isOnlineSale(order, ids);
}
